// src/views/Configuration/Configuration.jsx
import ConfigLayout from '../../layout/ConfigLayout/ConfigLayout';

const Configuration = ({ DesignSystemComponents }) => {
  return <ConfigLayout DesignSystemComponents={DesignSystemComponents} />;
};

export default Configuration;
